const mapKey = '28c2fbde13642a3d5cdd5ed96a6e4ba1';

export function setMapStyle(map: any) {
  map.setMapStyleV2({
    styleId: mapKey,
    version: 'v3',
  });
}
